/**
 * Utilidades de HTML seguras (evitan XSS).
 * - sanitizeHtml: limpia el HTML con DOMPurify antes de usarlo en dangerouslySetInnerHTML.
 * - htmlToText: extrae solo texto con DOMParser (no ejecuta scripts ni carga recursos).
 */
import DOMPurify from "dompurify";

export const sanitizeHtml = (html = "") => DOMPurify.sanitize(html || "");

export const htmlToText = (html = "") => {
  const doc = new DOMParser().parseFromString(html || "", "text/html");
  return (doc.body && doc.body.textContent) || "";
};
